<ion-content mode="ios">
  <div class="content">
    <div class="image-cropper-container">
      <image-cropper [imageBase64]="imageBase64" [aspectRatio]="1 / 1" [alignImage]="'center'" [onlyScaleDown]="true"
        output="base64" [resizeToHeight]="500" [resizeToWidth]="500" (imageLoaded)="onImageLoaded($event)"
        (imageCropped)="onImageCropped($event)">
      </image-cropper>
    </div>
    <div class="btns">
      <ion-button fill="clear" (click)="cancel()">{{'cancel'|language:'Cancel'}}</ion-button>
      <ion-button fill="clear" (click)="saveCroppedImage()">{{'save'|language:'Save'}}</ion-button>
    </div>
  </div>
</ion-content>